import { Component, h, Watch, Prop, Element } from '@stencil/core'

@Component({
    tag: 'c-menu-item',
    styles: 'c-menu-item.scss',
})

export class CMenuItem {
    @Element() el: HTMLElement
    @Prop() mType: string;
    @Prop() name: string;
    @Prop() url?: string;
    @Prop() isOpen: boolean;

    @Watch('isOpen')
    handleIsOpen(newValue: boolean) {
        if (newValue) {
            (this.el.querySelector('.menu-item') as HTMLElement).focus();
        }
    }

    // fetch Version from BE for Berufebot
    public fetchVersion = () : string => {
        return "Version: 0.8.49";
    }

    render() {
        return (
            this.mType === "Version" ? (
                <p class="v-number">{this.fetchVersion() || "Verson: 0.8.21"}</p>
            ) : (
                <a href={this.url} target='_blank' rel='noopener norefferer' class='menu-item' role='menuitem' aria-label={this.name} tabindex='0'
                data-analytics-track="true"
                data-analytics-action="LinkClicks TCB: Klick"
                data-analytics-value={this.name}
                data-analytics-name="TCB: Menu Link"
                data-analytics-category="TCB | LinkClicks">
                    <i aria-hidden="true" class="ba-icon ba-icon-chevron-right"/>
                    {this.name}
                </a>
            )
        )
    }
}